module.exports = __webpack_public_path__ + "static/media/Arrow.d7e176e6.svg";